var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCouponCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    fill: "none",
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "url(#prefix__paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1E7FF",
    d: "M13.734 23.639c-.74 0-1.347.612-1.347 1.36V39.28c0 .749.606 1.36 1.347 1.36h30.308V23.64H13.734z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#437BBE",
    d: "M54.145 42.001c0 .748-.606 1.36-1.347 1.36h-8.756v-2.72h8.756c.74 0 1.347-.612 1.347-1.36V42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#57A4FF",
    d: "M54.145 33.84v5.44c0 .749-.606 1.36-1.347 1.36h-8.756V23.64h8.756c.74 0 1.347.612 1.347 1.36V33.84z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FCBFF",
    d: "M13.734 40.64h30.308v2.721H13.734c-.74 0-1.347-.612-1.347-1.36v-2.72c0 .748.606 1.36 1.347 1.36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#004FAC",
    d: "M52.797 41.322H13.734c-1.114 0-2.02-.916-2.02-2.04V24.997c0-1.125.906-2.04 2.02-2.04h39.063c1.114 0 2.021.915 2.021 2.04v14.283c0 1.125-.907 2.04-2.02 2.04zM13.734 24.318c-.372 0-.674.305-.674.68v14.283c0 .376.302.68.674.68h39.063c.372 0 .674-.304.674-.68V24.998c0-.375-.302-.68-.673-.68H13.733z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#004FAC",
    d: "M52.797 44.042H13.734c-1.114 0-2.02-.915-2.02-2.04V28.399c0-.376.3-.68.673-.68.372 0 .673.304.673.68v13.603c0 .375.302.68.674.68h39.063c.372 0 .674-.305.674-.68V28.399c0-.376.301-.68.674-.68.372 0 .673.304.673.68v13.603c0 1.125-.907 2.04-2.02 2.04z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#004FAC",
    d: "M50.103 37.921c-.372 0-.673-.304-.673-.68V27.038c0-.376.3-.68.673-.68.373 0 .674.304.674.68v10.203c0 .376-.301.68-.674.68zM48.083 37.921c-.373 0-.674-.304-.674-.68V27.038c0-.376.301-.68.674-.68.372 0 .673.304.673.68v10.203c0 .376-.3.68-.673.68zM37.785 31.63H18.614c-.707 0-1.278-.577-1.278-1.29 0-.714.57-1.291 1.278-1.291h19.171c.707 0 1.279.577 1.279 1.29 0 .714-.572 1.291-1.279 1.291zM28.84 35.502H18.613c-.707 0-1.278-.577-1.278-1.29 0-.714.57-1.291 1.278-1.291h10.225c.707 0 1.279.577 1.279 1.29 0 .714-.572 1.291-1.279 1.291zM44.04 43.986c-.372 0-.673-.24-.673-.539v-19.95c0-.298.3-.539.673-.539.373 0 .674.241.674.54v19.95c0 .297-.301.538-.674.538z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear",
    x1: 33.5,
    x2: 33.5,
    y1: 0,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponCode);
export default __webpack_public_path__ + "static/media/coupon_code.c915b8e331b10c433956ebd66eb431fa.svg";
export { ForwardRef as ReactComponent };